import { ViewEncapsulation, ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-lift-gate-icon',
  template: '<xpo-icon *ngIf="isLiftGate" class="lift-gate-svg" iconName="SS_Liftgate"></xpo-icon>',
  styles: ['.xpo-Icon.lift-gate-svg > .mat-icon { padding: 7px 0 0 0; margin: 2px 0; height: 24px; }'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiftGateIconComponent implements ICellRendererAngularComp, IHeaderAngularComp {
  isLiftGate: boolean;

  constructor() {}

  agInit(params: any): void {
    this.isLiftGate = params.header ? params.header : params.value;
  }

  refresh(): boolean {
    return false;
  }
}
